module.exports = __webpack_public_path__ + "static/media/product-15.57179f41.jpg";